export default [
  {
    name: "Fee Setup",
    path: "/invoice_generator/fee_setup",
    meta: {
      layout: "Plain",
    },
    component: () => import("../Pages/Form"),
  },
];
